/**
 * Ismdan bosh harflarni oladi (avatar uchun).
 * "John Doe" → "JD", "John" → "J"
 */
export function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0] ?? '')
    .join('')
    .toUpperCase();
}
